<template>
  <div class="mb-6 p-4 border border-gray-200 rounded-lg bg-gray-50 shadow-sm">
    <h2 class="text-lg sm:text-xl font-semibold mb-3 text-gray-700">Upload Markdown Note</h2>
    <input type="file" @change="onFileChange" accept=".md,.markdown" class="..." />
    <p v-if="errorMessage" class="text-red-500 text-sm mt-2">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['file-uploaded'])
const errorMessage = ref('')

async function onFileChange(event) {
      errorMessage.value = '';
                    const file = event.target.files[0];

                    if (!file || (!file.name.endsWith('.md') && !file.name.endsWith('.markdown'))) {
                        errorMessage.value = 'Please upload a valid Markdown (.md or .markdown) file.';
                        event.target.value = '';
                        return;
                    }

                    const formData = new FormData();
                    formData.append("file", file);

                    try {
                        const response = await fetch("https://api.fare4z.com/enotes/upload", { // Existing API
                            method: "POST",
                            body: formData
                        });

                        const data = await response.json();

                        if (data.status === "success" && data.url) {
                            const fileResponse = await fetch(data.url);
                            const content = await fileResponse.text();

                            emit('file-uploaded', {
                                id: 'note-' + Date.now() + '-' + Math.random().toString(36).substring(2, 9),
                                name: file.name,
                                content: content,
                                createdAt: new Date().toISOString(),
                                url: data.url
                            });
                        } else {
                            errorMessage.value = data.message || 'Upload failed.';
                        }

                    } catch (err) {
                        console.error(err);
                        errorMessage.value = 'Upload failed. Please try again.';
                    }

                    event.target.value = '';
}
</script>
